<template>
  <div>
      <div class="traffic__legend-list">
        <div
          v-for="item in trafficLegendItems"
          :key="item.speed"
          class="traffic__legend-item"
        >
          <div
            class="traffic__legend-line"
            :style="{'background-color': item.color}"
          ></div>
          <div class="traffic__legend-value">
            <translated-text-component :translation="item.name" />
          </div>
        </div>
        <div class="traffic__legend-item">
          <div
            class="traffic__legend-line"
            :style="{'background-color': noDataColor}"
          ></div>
          <div class="traffic__legend-value">
            <translated-text-component translation="traffic_no_data" />
          </div>
        </div>
      </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, Ref, ref, computed, watch } from 'vue';
import store from '@/store';

const TrafficSmallLegend: object = defineComponent({
  props: {
  },
  name: 'TrafficSmallLegend',
  setup() {
    const noDataColor: Ref<string> = computed(() => store.state.segmentsConfig.no_data_color);
    const trafficLegend: Ref<any> = computed(() => store.getters.getTrafficLegend);
    const trafficLegendItems = ref<any>([]);
    const navActiveTab: Ref<number|null> = computed((): number|null => store.getters.getNavActiveTab);

    watch(() => navActiveTab.value, (selection, prevSelection) => {
      trafficLegendItems.value = Object.keys(trafficLegend.value).map((item: any) => {
      return {
        speed: trafficLegend.value[item].value,
        color: trafficLegend.value[item].color,
        name: trafficLegend.value[item].name,
      };
      }).sort((a, b) => a.speed - b.speed).reverse();
    });
   

    return {
      trafficLegend,
      noDataColor,
      trafficLegendItems,
    };
  },
});
export default TrafficSmallLegend;
</script>

<style scoped lang="scss">
.traffic__legend {

  &-list {
    padding: 5px 0;
  }

  &-item {
    display: flex;
    align-items: center;
    margin-bottom: 6px;
  }

  &-line {
    width: 30px;
    height: 4px;
    margin-right: 18px;
  }

  &-value {
    font-size: rem(12px);
    font-weight: 600;
    color: $main-font-color;
  }
}
</style>
